import React from 'react'

import ExplicitFilter from '../ExplicitFilter/ExplicitFilter'
import VocalFilter from '../VocalFilter/VocalFilter'
import styles from './VocalAndLyricsFilter.module.css'

const VocalAndLyricsFilter = (
	props: JSX.IntrinsicAttributes &
		React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement>
): JSX.Element => {
	return (
		<div className={styles.vocalsAndLyrics} {...props}>
			<VocalFilter />
			<ExplicitFilter />
		</div>
	)
}

export default VocalAndLyricsFilter
